(() => {
  const MOBILE = window.matchMedia('(max-width: 749px)');
  const SHELL_SELECTOR = '#MainContent .khushi-product-gallery-shell[data-khushi-enabled="true"]';

  function blockMobileZoom(event) {
    if (!MOBILE.matches) return;
    const target = event.target instanceof Element ? event.target : null;
    if (!target) return;

    const shell = target.closest(SHELL_SELECTOR);
    if (!(shell instanceof HTMLElement)) return;

    const zoomButton = target.closest('.product-media-container__zoom-button');
    const zoomableImageSlide = target.closest(
      'slideshow-slide.product-media-container--zoomable.product-media-container--image'
    );

    if (!zoomButton && !zoomableImageSlide) return;

    // Do not interfere with Horizon's pointer/scroll events; only suppress the
    // click action that opens the zoom dialog on touch-sized PDP layouts.
    if (!zoomButton && target.closest('a, input, select, textarea, model-viewer, deferred-media')) return;

    event.preventDefault();
    event.stopImmediatePropagation();
  }

  document.addEventListener('click', blockMobileZoom, true);
})();
